import { render } from "./Paquetes.vue?vue&type=template&id=26f6305c"
import script from "./Paquetes.vue?vue&type=script&lang=js"
export * from "./Paquetes.vue?vue&type=script&lang=js"

import "./Paquetes.vue?vue&type=style&index=0&id=26f6305c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__